import formatHomePageProductCollection from './formatHomePageProductCollection'

function formatDataOfPage(layouts = [], pageName = '') {
  return layouts.map((layout = {}) => {
    if (layout.name === 'ProductCollection') {
      const { data, name, value } = layout
      return {
        data,
        name,
        value: formatHomePageProductCollection(value, pageName),
      }
    }
    return layout
  })
}

export default formatDataOfPage
